export * from 'date-fns';

import no from 'date-fns/locale/nb/index';
import pl from 'date-fns/locale/pl/index';
import en from 'date-fns/locale/en-US/index';
import es from 'date-fns/locale/es/index';

export { no, pl, en, es };
